export const videoAssets = [
    {
        id: 'v1',
        type: 'video',
        name: '城市夜景.mp4',
        thumbnail: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=400',
        url: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=1920',
        duration: 5,
        size: '12.5 MB'
    },
    {
        id: 'v2',
        type: 'video',
        name: '海边日落.mp4',
        thumbnail: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400',
        url: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920',
        duration: 4,
        size: '10.2 MB'
    },
    {
        id: 'v3',
        type: 'video',
        name: '森林小径.mp4',
        thumbnail: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400',
        url: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1920',
        duration: 6,
        size: '15.8 MB'
    },
    {
        id: 'v4',
        type: 'video',
        name: '咖啡店.mp4',
        thumbnail: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400',
        url: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1920',
        duration: 3,
        size: '8.5 MB'
    },
    {
        id: 'v5',
        type: 'video',
        name: '山峰云海.mp4',
        thumbnail: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400',
        url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920',
        duration: 7,
        size: '18.3 MB'
    },
    {
        id: 'v6',
        type: 'video',
        name: '街道行人.mp4',
        thumbnail: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=400',
        url: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1920',
        duration: 4,
        size: '11.2 MB'
    }
];
export const audioAssets = [
    {
        id: 'a1',
        type: 'audio',
        name: '轻快钢琴.mp3',
        thumbnail: '🎵',
        url: '/audio/piano.mp3',
        duration: 120,
        size: '3.2 MB'
    },
    {
        id: 'a2',
        type: 'audio',
        name: '史诗配乐.mp3',
        thumbnail: '🎵',
        url: '/audio/epic.mp3',
        duration: 180,
        size: '4.8 MB'
    },
    {
        id: 'a3',
        type: 'audio',
        name: '环境音效.mp3',
        thumbnail: '🎵',
        url: '/audio/ambient.mp3',
        duration: 90,
        size: '2.5 MB'
    },
    {
        id: 'a4',
        type: 'audio',
        name: '欢快吉他.mp3',
        thumbnail: '🎵',
        url: '/audio/guitar.mp3',
        duration: 150,
        size: '3.8 MB'
    }
];
export const imageAssets = [
    {
        id: 'i1',
        type: 'image',
        name: '标题背景.jpg',
        thumbnail: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=400',
        url: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920',
        size: '2.1 MB'
    },
    {
        id: 'i2',
        type: 'image',
        name: '渐变背景.jpg',
        thumbnail: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=400',
        url: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1920',
        size: '1.8 MB'
    },
    {
        id: 'i3',
        type: 'image',
        name: '纹理背景.jpg',
        thumbnail: 'https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?w=400',
        url: 'https://images.unsplash.com/photo-557682224-5b8590cd9ec5?w=1920',
        size: '2.3 MB'
    },
    {
        id: 'i4',
        type: 'image',
        name: '抽象图案.jpg',
        thumbnail: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?w=400',
        url: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?w=1920',
        size: '1.9 MB'
    },
    {
        id: 'i5',
        type: 'image',
        name: '几何图形.jpg',
        thumbnail: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=400',
        url: 'https://images.unsplash.com/photo-1557672172-298e090bd0f1?w=1920',
        size: '2.0 MB'
    },
    {
        id: 'i6',
        type: 'image',
        name: '光影效果.jpg',
        thumbnail: 'https://images.unsplash.com/photo-1557682268-e3955ed5d83f?w=400',
        url: 'https://images.unsplash.com/photo-1557682268-e3955ed5d83f?w=1920',
        size: '2.2 MB'
    }
];
